/* ============================================================
   [vb] Interaktion — 13.09.2026
   1) Produkt fliegt beim Kauf in den Warenkorb
   2) Der Kaufbalken spiegelt den Ladezustand des echten Knopfes
   3) (18.09.2026) Grosse Versal-Ueberschriften passen sich ein: ein
      einzelnes langes Wort (z. B. QUALITAETSVERSPRECHEN.) wird kleiner
      gesetzt, statt ueber den Rand zu laufen oder mitten im Wort zu
      brechen. Gehoert zu Abschnitt 13 in vb-motion.css.

   Bewusst NICHT hier: eine Bewegung beim Preiswechsel. War am
   13.09. gebaut und auf Wunsch wieder entfernt — der Preis
   tauscht ohne Uebergang. Nicht erneut einbauen.

   Nicht enthalten, weil das Theme es schon kann — am 13.09. im
   Browser nachgemessen, nicht vermutet:
   - Wartezustand am Kaufknopf: component-product-form.js setzt
     beim Absenden die Klasse "working" und nimmt sie im finally
     wieder weg; theme.css blendet dann die Beschriftung aus und
     den Kreisel ein. Haengt an der echten Antwort, nicht an einem
     Timer. Besser als alles, was hier haette stehen koennen.
   - Klapptexte: ToggleTab faehrt die Hoehe selbst (slideUp/Down,
     200 ms). Gemessen: 0 -> 459 px in rund 200 ms. Kein Sprung.
   ============================================================ */
(function () {
  'use strict';

  var SANFT = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KURVE = 'cubic-bezier(0.23,1,0.32,1)';

  /* Stilblock nur anlegen, wenn wirklich gebraucht. */
  var stilDa = false;
  function stil() {
    if (stilDa) return;
    stilDa = true;
    var s = document.createElement('style');
    s.textContent =
      /* Farbe wird vor dem Umschalten in --vb-ring gesichert, darum
         darf color hier gefahrlos transparent werden — der Knopf
         behaelt seine Breite, nichts springt. */
      '.vb-laedt{position:relative;pointer-events:none;color:transparent !important}' +
      '.vb-laedt::after{content:"";position:absolute;left:50%;top:50%;' +
        'width:18px;height:18px;margin:-9px 0 0 -9px;border-radius:50%;' +
        'border:2px solid var(--vb-ring,#fff);border-top-color:transparent;' +
        'animation:vb-dreh .7s linear infinite}' +
      '@keyframes vb-dreh{to{transform:rotate(360deg)}}' +
      /* Ohne Bewegung: kein Kreisel, dafuer Beschriftung zurueck und
         gedimmt — der Zustand bleibt ablesbar. */
      '@media (prefers-reduced-motion:reduce){' +
        '.vb-laedt{color:var(--vb-ring) !important;opacity:.62}' +
        '.vb-laedt::after{display:none}}';
    document.head.appendChild(s);
  }

  /* =========================================================
     1) Flug in den Warenkorb
     ========================================================= */

  /* Von den drei Warenkorb-Symbolen im Kopf ist je nach Breite nur
     eines sichtbar. Wir nehmen das mit echter Ausdehnung. */
  function warenkorbSymbol() {
    var kandidaten = document.querySelectorAll('a.area--cart, .area--cart');
    for (var i = 0; i < kandidaten.length; i++) {
      var r = kandidaten[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.top < innerHeight) return kandidaten[i];
    }
    return null;
  }

  /* Auf der Produktseite liegen die Galeriebilder als Streifen
     nebeneinander (gemessen am 13.09.: links 0, 390, 780, ...).
     Sichtbar ist das, dessen Mitte der Mitte des Rahmens am
     naechsten liegt. */
  function galerieBild() {
    var galerie = document.querySelector('.product-gallery');
    if (!galerie) return null;
    var rahmen = galerie.getBoundingClientRect();
    var mitte = rahmen.left + rahmen.width / 2;
    var beste = null, besterAbstand = Infinity;
    var bilder = galerie.querySelectorAll('img');
    for (var i = 0; i < bilder.length; i++) {
      var r = bilder[i].getBoundingClientRect();
      if (r.width < 100 || r.height < 100) continue;          /* Vorschaubilder raus */
      if (!(bilder[i].currentSrc || bilder[i].src)) continue;
      var abstand = Math.abs(r.left + r.width / 2 - mitte);
      if (abstand < besterAbstand) { besterAbstand = abstand; beste = bilder[i]; }
    }
    return beste;
  }

  function quellBild(knopf) {
    /* Produktseite zuerst. Der bisherige Weg lief hier ins Leere:
       keine der Karten-Klassen trifft zu, also fiel er auf das
       <form> zurueck — und darin steckt nur ein 56 px grosses
       Vorschaubild aus dem Kaufbereich. Am 13.09. nachgemessen:
       es flog das falsche Bild los. */
    if (knopf.closest('product-page, .product-text, .product-actions')) {
      var g = galerieBild();
      if (g) return g;
    }

    /* closest() nimmt den NAECHSTEN Treffer, und der Kauf-Knopf steckt in
       einem <form> in der Karte. Also erst die Karte, dann das Formular. */
    var karte = knopf.closest('.product-item, .product-item-compact, .product-main, .product-block, .card')
             || knopf.closest('form');
    if (!karte) return null;

    /* Nicht naturalWidth pruefen: lazy geladene Bilder sind noch nicht
       dekodiert und wuerden faelschlich verworfen. Die gerenderte
       Groesse sagt zuverlaessig, welches Bild der Kunde wirklich sieht. */
    var kandidaten = karte.querySelectorAll(
      '.product-item__image img, .product-media img, figure img, img');
    for (var i = 0; i < kandidaten.length; i++) {
      var r = kandidaten[i].getBoundingClientRect();
      if (r.width > 24 && r.height > 24 && (kandidaten[i].currentSrc || kandidaten[i].src)) {
        return kandidaten[i];
      }
    }
    return null;
  }

  /* Woher der Flug startet: Bildadresse plus Startrechteck.
     Getrennt, weil der Kaufbalken beides aus verschiedenen Quellen
     zieht — Adresse vom (auf dem Handy ausgeblendeten) Balkenbild,
     Startpunkt vom Balken selbst. */
  function quelle(knopf) {
    var balken = knopf.closest('.vbkb');
    if (balken) {
      var eigen = balken.querySelector('.vbkb__bild');
      var adresse = eigen && (eigen.currentSrc || eigen.src);
      if (!adresse) {
        var g0 = galerieBild();
        adresse = g0 && (g0.currentSrc || g0.src);
      }
      if (!adresse) return null;

      var br = eigen && eigen.getBoundingClientRect();
      if (!br || br.width < 10) {
        /* Gemessen am 13.09.: unter 680 px blendet der Balken sein
           Bild aus (display:none, Breite 0). Die Galerie waere als
           Start falsch — wenn der Balken zu sehen ist, ist sie aus
           dem Bild gescrollt. Also startet der Flug am Balken. */
        var kr0 = balken.getBoundingClientRect();
        br = { left: kr0.left + 14, top: kr0.top + (kr0.height - 44) / 2, width: 44, height: 44 };
      }
      return { src: adresse, rect: br };
    }

    var el = quellBild(knopf);
    if (!el) return null;
    var r = el.getBoundingClientRect();

    /* Liegt die Quelle ganz ausserhalb des Bildes, faengt der Flug
       am Knopf an. Am 13.09. gemessen: wer weit genug gescrollt hat,
       um den Kaufknopf zu sehen, hat die Galerie rund 800 px ueber
       sich — der Start lag bei y = -53, also unsichtbar. Eine
       Bewegung, die ausserhalb beginnt, erklaert nichts. */
    if (r.bottom < 8 || r.top > innerHeight - 8) {
      var kr = knopf.getBoundingClientRect();
      var kante = Math.min(kr.height, 64);
      r = { left: kr.left + kr.width / 2 - kante / 2, top: kr.top + kr.height / 2 - kante / 2,
            width: kante, height: kante };
    }
    return { src: el.currentSrc || el.src, rect: r };
  }

  function fliegen(q, ziel) {
    var von = q.rect;
    var nach = ziel.getBoundingClientRect();
    if (!von.width || !nach.width) return;

    var kante = Math.min(von.width, von.height, 130);

    /* Zwei Ebenen: aussen waagerecht, innen senkrecht. Getrennte Kurven
       ergeben einen Bogen — waagerecht schnell heraus (ease-out),
       senkrecht beschleunigend hinein (ease-in) wie beim Fallen. */
    var huelle = document.createElement('div');
    huelle.style.cssText =
      'position:fixed;left:0;top:0;width:' + kante + 'px;height:' + kante + 'px;' +
      'z-index:2147483000;pointer-events:none;will-change:transform;' +
      'transform:translate3d(' + (von.left + von.width / 2 - kante / 2) + 'px,' +
      (von.top + von.height / 2 - kante / 2) + 'px,0)';

    var kern = document.createElement('div');
    kern.style.cssText =
      'width:100%;height:100%;border-radius:14px;overflow:hidden;will-change:transform;' +
      'box-shadow:0 12px 28px rgba(5,55,30,.32);background:#f5f1e8;' +
      'background-image:url("' + q.src + '");' +
      'background-size:cover;background-position:center';

    huelle.appendChild(kern);
    document.body.appendChild(huelle);

    var dx = nach.left + nach.width / 2 - (von.left + von.width / 2);
    var dy = nach.top + nach.height / 2 - (von.top + von.height / 2);
    var DAUER = 420;   /* Strecke quer ueber den Bildschirm, darum ueber dem UI-Budget */

    var a1 = huelle.animate(
      [{ transform: huelle.style.transform },
       { transform: 'translate3d(' + (von.left + von.width / 2 - kante / 2 + dx) + 'px,' +
                    (von.top + von.height / 2 - kante / 2) + 'px,0)' }],
      { duration: DAUER, easing: KURVE, fill: 'forwards' });

    var a2 = kern.animate(
      [{ transform: 'translateY(0) scale(1)', opacity: 1, offset: 0 },
       { transform: 'translateY(' + (dy * 0.35) + 'px) scale(.72)', opacity: 1, offset: .55 },
       { transform: 'translateY(' + dy + 'px) scale(.18)', opacity: 0, offset: 1 }],
      { duration: DAUER, easing: 'cubic-bezier(0.55,0,1,0.45)', fill: 'forwards' });

    var fertig = 0;
    function aufraeumen() {
      if (++fertig < 2) return;
      huelle.remove();
      stupsen(ziel);
    }
    a1.onfinish = aufraeumen;
    a2.onfinish = aufraeumen;
    setTimeout(function () { if (huelle.parentNode) { huelle.remove(); } }, DAUER + 400);
  }

  /* Der Warenkorb quittiert den Empfang */
  function stupsen(ziel) {
    ziel.animate(
      [{ transform: 'scale(1)' },
       { transform: 'scale(1.22)' },
       { transform: 'scale(1)' }],
      { duration: 260, easing: KURVE });
  }

  /* =========================================================
     2) Kaufbalken spiegelt den Ladezustand
     Der Balken klickt den echten Knopf. Der geht daraufhin in
     seinen "working"-Zustand — sichtbar ist er dabei aber nicht,
     sonst waere der Balken gar nicht da. Ergebnis bisher: man
     tippt und nichts passiert. Wir uebernehmen den Zustand.
     Laeuft auch bei reduzierter Bewegung, denn das ist
     Rueckmeldung und keine Zierde.
     ========================================================= */
  function echterKnopf() {
    var f = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < f.length; i++) {
      var b = f[i].querySelector('[name="add"]');
      if (b) return b;
    }
    return null;
  }

  function balkenSpiegel(versuch) {
    var balken = document.querySelector('.vbkb [data-vbkb-knopf]');
    if (!balken) return;
    var echt = echterKnopf();
    if (!echt) {
      /* Der Balken haengt in der Kopfgruppe, das Formular kommt
         spaeter. Ein paar Runden warten, dann aufgeben. */
      if ((versuch || 0) < 20) setTimeout(function () { balkenSpiegel((versuch || 0) + 1); }, 200);
      return;
    }
    stil();
    var an = false;
    function abgleichen() {
      var arbeitet = echt.classList.contains('working');
      if (arbeitet === an) return;
      an = arbeitet;
      if (arbeitet) {
        balken.style.setProperty('--vb-ring', getComputedStyle(balken).color);
        balken.classList.add('vb-laedt');
      } else {
        balken.classList.remove('vb-laedt');
        balken.style.removeProperty('--vb-ring');
      }
    }
    new MutationObserver(abgleichen).observe(echt, { attributes: true, attributeFilter: ['class'] });
    abgleichen();
  }

  /* =========================================================
     3) Grosse Versal-Ueberschriften einpassen (18.09.2026)
     Nur wenn ein Wort breiter ist als der verfuegbare Platz: dann
     schrittweise kleiner, bis es passt (nicht unter 18 px). Sonst
     bleibt alles, wie das CSS es setzt.
     FALLSTRICK (gemessen): manche Ueberschriften sind so breit wie
     ihr Text (Landingpage-Phasen). Die Box schrumpft mit der Schrift
     mit, der Vergleich mit der aktuellen Breite kaeme nie ans Ziel.
     Darum zaehlt die Breite VOR dem Verkleinern als Grenze.
     ========================================================= */
  var GROSS = '.vbab__title,.vbt__title,.vbzs__head,.vbpr2__h,.we-subscription-banner__heading,' +
    '.vbst__h,.vbpa__title,.vbph__title,.vbti__title,.vbm__title,.vbfs-teaser__title,.vbfs-hero__title,' +
    '.vbfs-page__title,.vbfs-band__title,.vbfs-sign__title,.vbw__title,.we-faq-title,.section-heading__title,' +
    '.hybrid-scroll-phase__heading,.rich-text h2,main h2.heading-size--small,.we-hero-video__heading';
  function passeEin(h) {
    if (!h.offsetParent) return;
    h.style.removeProperty('font-size');
    var grenze = h.clientWidth;
    h.__vbGrenze = grenze;
    var fs = parseFloat(getComputedStyle(h).fontSize);
    var n = 0;
    while (h.scrollWidth > grenze + 1 && fs > 18 && n < 40) {
      fs -= 1; n++;
      h.style.setProperty('font-size', fs + 'px', 'important');
    }
    h.__vbEnde = h.clientWidth;
  }
  function einpassen() {
    var liste = document.querySelectorAll(GROSS);
    for (var i = 0; i < liste.length; i++) passeEin(liste[i]);
  }
  var einpassWarte;
  function einpassenSpaeter() { clearTimeout(einpassWarte); einpassWarte = setTimeout(einpassen, 150); }
  function einpassenBeobachten() {
    var liste = document.querySelectorAll(GROSS);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        e.forEach(function (x) { if (x.isIntersecting) passeEin(x.target); });
      });
      for (var i = 0; i < liste.length; i++) io.observe(liste[i]);
    }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (e) {
        e.forEach(function (x) {
          var w = x.target.clientWidth;
          if (w !== x.target.__vbEnde && w !== x.target.__vbGrenze) passeEin(x.target);
        });
      });
      for (var j = 0; j < liste.length; j++) ro.observe(liste[j]);
    }
  }

  /* =========================================================
     Verdrahtung
     ========================================================= */
  var gesperrtBis = 0;
  document.addEventListener('click', function (e) {
    if (SANFT) return;
    var knopf = e.target.closest('button[name="add"], .add-to-cart, .we-atc, [data-vbkb-knopf]');
    if (!knopf || knopf.disabled) return;
    var jetzt = Date.now();
    if (jetzt < gesperrtBis) return;      /* Doppeltipp faengt sich nicht selbst ein */
    gesperrtBis = jetzt + 320;

    var ziel = warenkorbSymbol();
    var q = quelle(knopf);
    if (ziel && q) fliegen(q, ziel);
  }, true);

  function start() {
    balkenSpiegel(0);
    einpassen();
    einpassenBeobachten();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(einpassen);
    window.addEventListener('resize', einpassenSpaeter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
